export default __webpack_public_path__ + "static/media/cryc10.5d8665c5.svg";